import React, { useEffect } from 'react';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { Stack } from '@fiverr-private/layout_components';
import { globalBigQueryReporter, globalGrafanaReporter, globalMixpanelReporter } from '../../events';
import { InitialStepTitle } from '../InitialStepTitle';
import { SocialSigningForm } from '../SocialSigningForm';
import { WnWInfoSection } from '../WnWInfoSection';
import { Disclaimer } from '../Disclaimer';

export const InitialStep = () => {
    const { variant, mode } = useIdentificationContext();
    const isWnwFlow = variant === 'wnw_direct' || variant === 'wnw_dashboard';
    const showWnWInfo = isWnwFlow && mode === 'sign_up';

    useEffect(() => {
        globalGrafanaReporter.count('identification.%{platform}.initial.show');
        globalMixpanelReporter.send('Identification - Initial - Show');
        globalBigQueryReporter.send('identification.initial.show');
    }, []);

    if (variant === 'onboarding') {
        return (
            <Stack maxWidth="520px" direction="column" textAlign="center" maxHeight="100%">
                <InitialStepTitle />
                <SocialSigningForm />
                <Disclaimer />
            </Stack>
        );
    }

    return (
        <>
            <InitialStepTitle />
            {showWnWInfo && <WnWInfoSection />}
            <SocialSigningForm />
        </>
    );
};
